/** Get Summary Dashboard data */
export const DEBUG_SCREEN_API_SUCCESS = "DEBUG_SCREEN_API_SUCCESS";
export const DEBUG_SCREEN_API_FAIL = "DEBUG_SCREEN_API_FAIL";
export const GET_DEBUG_SCREEN_DATA = "GET_DEBUG_SCREEN_DATA";
export const SET_LOADING= "SET_LOADING";